import React, { Component } from 'react';

import './cats.styles.css';
import CatsSelector from './cats.selector';
import CatsContainer from './cats.container';

export default class Cats extends Component {
  state = {};

  componentDidMount() {}

  componentDidUpdate() {}

  render() {
    return (
      <article className="Cats">
        <CatsSelector />
        <CatsContainer />
      </article>
    );
  }
}
